(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["owf-coach-directory"] && !Shopify.designMode) return;
  try {
    
  function initializeOwfCoachDirectory(root) {
    if (root.dataset.coachDirectoryReady === 'true') return;
    root.dataset.coachDirectoryReady = 'true';

    const grid = root.querySelector('[data-coach-grid]');
    const cards = Array.from(root.querySelectorAll('[data-coach-card]'));
    const buttons = Array.from(root.querySelectorAll('[data-coach-filter]'));
    const emptyState = root.querySelector('[data-coach-empty]');

    if (grid) {
      cards
        .sort((firstCard, secondCard) => {
          const orderDifference = Number(firstCard.dataset.coachSort) - Number(secondCard.dataset.coachSort);
          return orderDifference || firstCard.dataset.coachName.localeCompare(secondCard.dataset.coachName);
        })
        .forEach((card) => grid.appendChild(card));
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const selectedFilter = button.dataset.coachFilter;
        let visibleCount = 0;

        buttons.forEach((candidate) => {
          const isSelected = candidate === button;
          candidate.classList.toggle('is-active', isSelected);
          candidate.setAttribute('aria-pressed', String(isSelected));
        });

        cards.forEach((card) => {
          const programs = card.dataset.coachPrograms || '';
          const isVisible = selectedFilter === 'all' || programs.includes(selectedFilter);
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        if (emptyState) emptyState.hidden = visibleCount !== 0;
      });
    });
  }

  function initializeAllOwfCoachDirectories(scope = document) {
    scope.querySelectorAll('[data-coach-directory]').forEach(initializeOwfCoachDirectory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllOwfCoachDirectories());
  } else {
    initializeAllOwfCoachDirectories();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllOwfCoachDirectories(event.target));

  } catch(e) { console.error(e); }
})();
})();
